import { getContext, Transport, Part } from 'tone'

export function setTransportBPM(value) {
  Transport.bpm.rampTo(value)
}

export function setTransportLooping(value) {
  Transport.loop = value
}

export function getIsTransportStarted() {
  return Transport.state === 'started'
}

export function resetTransport() {

}

export function startTransport(start) {
  if(getContext().state !== 'running') {
    getContext().resume()
  }
  Transport.start('+0.1', start)
}

export function stopTransport() {
  Transport.stop()
}

export function setTransportTimeSignature(timeSig) {
  Transport.timeSignature = timeSig
}


function voiceToTonePartEvents(voiceName, voiceData) {
  const events = []
  voiceData.forEach((measure, mIndex) => {
    const overallTime   = { '1m': mIndex }
    const measureEvents = measure.data.map(({ notes, duration }, index) => {
      if(notes) {
        const events = { notes: [...notes], dur: duration, time: { ...overallTime }, index, mIndex, voiceName }
        if(!overallTime[duration]) {
          overallTime[duration] = 0
        }
        ++overallTime[duration]
        return events
      }
    })
    events.push(...measureEvents)
  })
  return events
}

export function scoreToParts(score, callback) {
  const partEvents = {}
  Object.entries(score.voices).forEach(([voiceName, voiceData]) => {
    const voiceEvents     = voiceToTonePartEvents(voiceName, voiceData)
    const part            = new Part(callback, voiceEvents)
    part.loopEnd          = score.length
    part.loop             = true
    partEvents[voiceName] = part
  })

  return partEvents
}
